import FormControlLabel from '@zenbusiness/zui/FormControlLabel';
import { styled } from '@zenbusiness/zui/styles';

export const FormControlLabelStyled = styled(FormControlLabel)(({ theme }) => ({
  borderRadius: '16px',
  border: `1px solid ${theme.palette.border.main}`,
  width: '100%',
  padding: '24px',
  verticalAlign: 'text-top',
  '& .MuiCheckbox-root': {
    alignSelf: 'flex-start'
  },
  marginLeft: 0,
  marginRight: 0,
  [theme.breakpoints.up('md')]: {
    padding: '32px'
  }
}));
